import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Modal } from '@/features/modals/components';
import { modalInteraction } from '@/actions';
import { buildLayer } from '@/reducers/layers';
import modal from '../../../../css/module/modal.css';
import TableRef from '../../../../util/TableRef';
import ModalWhere from '../../../../components/modals/ModalWhere';

const DashboardCustomFilterModalContainer = styled(Modal)`
  gap: var(--spacing-xl);
  padding: 48px;
  width: 624px;
  max-width: 624px;
`;

class DashboardCustomFilterModal extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { modals } = this.props;
    const modalType = ModalWhere.modalType();
    const state = ModalWhere.reducer(modals);
    const layer = buildLayer(modalType, state);
    this.props.onDone(layer);
  }

  render() {
    const { modals, userInteraction, column } = this.props;

    const modalType = ModalWhere.modalType();
    const state = ModalWhere.reducer(modals);

    if (!column) {
      return null;
    }

    const content = React.createElement(ModalWhere, {
      state,
      userInteraction: userInteraction(modalType),
      columns: [column],
      usedAliases: {
        [column.name().alias()]: new TableRef('???', '!!!'),
      },
      forcedColumn: column,
    });

    return (
      <DashboardCustomFilterModalContainer
        title="Add filter"
        onSubmit={this.handleSubmit}
        className={modal.container}
        isSubmitDisabled={!state.readyForSave}
      >
        {content}
      </DashboardCustomFilterModalContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modals: state.modals,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userInteraction: (modalType) => (props) => (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(modalInteraction(modalType, props));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardCustomFilterModal);
